import { createSlice } from '@reduxjs/toolkit';

export const paramsSlice = createSlice({
    name: "params",
    initialState: {
        selector: ''
    },
    reducers: {
        paramsChange: (state, action) => {
            return {
                ...state,
                selector: action.payload
            }
        }
    }
})

export const { paramsChange } = paramsSlice.actions

export default paramsSlice.reducer